import { keepPreviousData, useQuery } from "@tanstack/react-query";
import apiClient from "../../../lib/api_client";

export const fetchDesignSourceReport = async ({
  startDate,
  endDate,
  section,
  clientCode,
  search,
  eventTypeId,
}) => {
  const response = await apiClient.get("/designAddStats/list", {
    params: { startDate, endDate, section, clientCode, search, eventTypeId },
  });
  return response?.data?.data;
};

export const useDesignSourceReport = ({
  startDate,
  endDate,
  section,
  clientCode,
  search,
  eventTypeId,
}) => {
  return useQuery({
    queryKey: ["designSourceReport", startDate, endDate, section, clientCode, search, eventTypeId],
    queryFn: () =>
      fetchDesignSourceReport({ startDate, endDate, section, clientCode, search, eventTypeId }),
    placeholderData: keepPreviousData,
  });
};

export const fetchDesignAnalytics = async ({ startDate, endDate, search, eventTypeId }) => {
  const response = await apiClient.get("/designAddStats/analytics", {
    params: { startDate, endDate, search, eventTypeId },
  });
  return response?.data?.data;
};

export const useDesignAnalytics = ({ startDate, endDate, search, eventTypeId }) => {
  return useQuery({
    queryKey: ["designAnalytics", startDate, endDate, search, eventTypeId],
    queryFn: () => fetchDesignAnalytics({ startDate, endDate, search, eventTypeId }),
    placeholderData: keepPreviousData,
  });
};
